//@ts-nocheck
/**
 * src/routes/sections/auth.tsx
 * ---------------------------------------------------------------------------
 * Auth section: login route.
 * Extracted from the monolithic routes.tsx for clarity.
 * All existing route paths and components are preserved exactly.
 */
import React from 'react';
import Login from '../../Pages/Login';
import ForgotPassword from '../../Pages/Auth/ForgotPassword';
import ResetPassword from '../../Pages/Auth/ResetPassword';

export const authRoutes = [
  { path: '/login', element: <Login /> },
  { path: '/forgot-password', element: <ForgotPassword /> },
  { path: '/reset-password', element: <ResetPassword /> },
];
